import styled from 'styled-components';

export const StyledMetaversePopupTitle = styled.div`
  width: 100%;

  .metaverse-popup-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.5rem 2rem;
    font-family: "NeueMachina";
    font-size: 2em;
    line-height: 1em;
    font-weight: 500;
    text-transform: uppercase;
    justify-content: space-between;
    gap: 20px;

    .metaverse-popup-title-text-bold {
      font-weight: 700;
      color: ${({ theme }) => theme.selection};
    }
    
    img {
      width: 185px;
      min-width: 185px;
    }
  }
`;
